// Italian region display names (ITTER107-aligned codes) — EN + IT.
// Backend labels are ISTAT Italian names; these override per locale.
export const REGION_NAMES = {
  en: {
    ITC1: "Piedmont", ITC2: "Aosta Valley", ITC3: "Liguria", ITC4: "Lombardy",
    ITD1: "Bolzano/South Tyrol", ITD2: "Trento", ITD3: "Veneto",
    ITD4: "Friuli-Venezia Giulia", ITD5: "Emilia-Romagna",
    ITDA: "Trentino-Alto Adige", ITE1: "Tuscany", ITE2: "Umbria",
    ITE3: "Marche", ITE4: "Lazio", ITF1: "Abruzzo", ITF2: "Molise",
    ITF3: "Campania", ITF4: "Apulia", ITF5: "Basilicata", ITF6: "Calabria",
    ITG1: "Sicily", ITG2: "Sardinia",
    ITC: "North-West", ITD: "North-East", ITE: "Centre",
    SUD_ISOLE: "South & Islands", UNALLOC: "Unallocated",
  },
  it: {
    ITC1: "Piemonte", ITC2: "Valle d'Aosta", ITC3: "Liguria", ITC4: "Lombardia",
    ITD1: "Bolzano/Alto Adige", ITD2: "Trento", ITD3: "Veneto",
    ITD4: "Friuli-Venezia Giulia", ITD5: "Emilia-Romagna",
    ITDA: "Trentino-Alto Adige", ITE1: "Toscana", ITE2: "Umbria",
    ITE3: "Marche", ITE4: "Lazio", ITF1: "Abruzzo", ITF2: "Molise",
    ITF3: "Campania", ITF4: "Puglia", ITF5: "Basilicata", ITF6: "Calabria",
    ITG1: "Sicilia", ITG2: "Sardegna",
    ITC: "Nord-Ovest", ITD: "Nord-Est", ITE: "Centro",
    SUD_ISOLE: "Sud e Isole", UNALLOC: "Non ripartito",
  },
};

export const regionName = (code, lang, fallback) =>
  REGION_NAMES[lang]?.[code] || REGION_NAMES.en[code] || fallback || code;

// Country display names for BdI origin aggregates/countries (label_en from BdI)
export const ORIGIN_NAMES_IT = {
  EU: "Europa — UE", EUR_X_EU: "Europa — Extra UE", AMERICA: "America",
  AFRICA: "Africa", ASIA: "Asia", OCEANIA: "Oceania",
  DEU: "Germania", FRA: "Francia", AUT: "Austria", ESP: "Spagna",
  GBR: "Regno Unito", CHE: "Svizzera", RUS: "Russia", USA: "Stati Uniti",
  CAN: "Canada", JPN: "Giappone",
};
